import React from "react";
import { motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

import aboutImg from "../../assets/About/aboutImg.jpg";
import aboutCartoon from "../../assets/About/aboutCartoon.jpg";
import aboutImgNoBg from "../../assets/About/aboutImgNoBg.png";
import developerNoBg from "../../assets/About/developerNoBg.png";

// components

const aboutImgVariants = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
		x: 0,
	},
	exit: {
		opacity: 0,
	},
	transition: {
		duration: 0.5,
	},
};

const AboutImage = () => {
	const { theme } = useTheme();

	return (
		<motion.div
			variants={aboutImgVariants}
			{...aboutImgVariants}
			className={`${
				theme === "dark" ? "border-white" : "border-black"
			} border-2 rounded-full overflow-hidden max-w-xs lg:max-w-sm order-first lg:order-last`}>
			<img
				src={aboutCartoon}
				alt="about psd image"
				className="h-[350px] md:h-auto max-w-full rounded-full relative"
			/>
		</motion.div>
	);
};

export default AboutImage;
